import { useState } from "react";
import { Link, useLocation } from "react-router-dom";

export default function Navbar() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  const isActive = (path) => location.pathname === path;

  return (
    <nav className="navbar">
      <div className="container navbar-inner">
        <Link to="/" className="brand-logo">
          <div className="logo-monogram">RS</div>
          <div className="brand-title-wrap">
            <span className="brand-name">RAJESH SIVACHARYA</span>
            <span className="brand-sub">THE IDENTITY SHIFT™</span>
          </div>
        </Link>

        <button
          className="mobile-toggle"
          aria-label="Toggle navigation"
          onClick={() => setMobileOpen(!mobileOpen)}
        >
          ☰
        </button>

        <ul className={`nav-links${mobileOpen ? " mobile-open" : ""}`}>
          <li><Link to="/" className={`nav-link${isActive("/") ? " active" : ""}`} onClick={() => setMobileOpen(false)}>Home</Link></li>
          <li><Link to="/identity-shift" className={`nav-link${isActive("/identity-shift") ? " active" : ""}`} onClick={() => setMobileOpen(false)}>The Identity Shift™</Link></li>
          <li><Link to="/career-wealth" className={`nav-link${isActive("/career-wealth") ? " active" : ""}`} onClick={() => setMobileOpen(false)}>Career &amp; Wealth</Link></li>
          {/* <li><Link to="/about" className={`nav-link${isActive("/about") ? " active" : ""}`} onClick={() => setMobileOpen(false)}>About</Link></li> */}
          <li><Link to="/checkout" className={`nav-link${isActive("/checkout") ? " active" : ""}`} onClick={() => setMobileOpen(false)}>Shop</Link></li>
          <li><Link to="/free-guide" className={`nav-link${isActive("/free-guide") ? " active" : ""}`} onClick={() => setMobileOpen(false)} style={{ color: isActive("/free-guide") ? undefined : "var(--gold-warm)", fontWeight: 700 }}>Free Guide</Link></li>
        </ul>

        {/* <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
          <Link to="/checkout" className="btn btn-primary-gold btn-sm">EXPLORE COLLECTION</Link>
        </div> */}
      </div>
    </nav>
  );
}
